import { JwksValidationHandler, ValidationParams } from 'angular-oauth2-oidc';

export class MyJwksValidationHandler extends JwksValidationHandler {
    override async validateAtHash(params: ValidationParams): Promise<boolean> {
        return true;
    }
}